var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCreditCardOutline = function SvgCreditCardOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 14a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M19 3a5.007 5.007 0 0 1 5 5v8a5.007 5.007 0 0 1-5 5H5a5.007 5.007 0 0 1-5-5V8a5.007 5.007 0 0 1 5-5zM2 10v6a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-6zm3-5a3 3 0 0 0-3 3h20a3 3 0 0 0-3-3z",
    clipRule: "evenodd"
  })));
};
export default SvgCreditCardOutline;